import { get as fetch, put } from '../shared/utils/fetch.util'

export const get = () => fetch('/v2/applications').then(resp => resp.data)
export const accept = id =>
  put(`/v2/applications/${id}`, { type: 'acceptance' }).then(resp => resp.data)
export const decline = id =>
  put(`/v2/applications/${id}`, { type: 'rejection' }).then(resp => resp.data)
